export type RankItem = {
  id: number;
  title: string;
  summary: string;
  tag: string;
  heat: number;
  trend: "up" | "down" | "flat";
};

export type CollectionItem = {
  title: string;
  summary: string;
  tag: string;
};

export type Collection = {
  id: number;
  key: string;
  kicker: string;
  name: string;
  desc: string;
  icon: string;
  accent: string;
  trendLabel: string;
  items: CollectionItem[];
};

export type Brief = {
  id: number;
  time: string;
  group: "刚刚" | "今天" | "昨日";
  title: string;
  summary: string;
  tag: string;
};

export type Update = {
  id: number;
  date: string;
  title: string;
  note: string;
  kind: "入口" | "同步" | "维护";
};

export const navLinks = [
  { label: "今日热榜", href: "#hot" },
  { label: "专题合集", href: "#topics" },
  { label: "短讯速览", href: "#briefs" },
  { label: "热词飙升", href: "#words" },
  { label: "更新动态", href: "#updates" },
  { label: "关于本站", href: "#about" },
];

export const heroStats = [
  { value: "24h", label: "实时滚动" },
  { value: "6+", label: "圈层专题" },
  { value: "∞", label: "追瓜不掉线" },
];

export const rankCategories = ["综合", "娱乐", "商界", "科技", "体坛"] as const;

export const rankList: RankItem[] = [
  {
    id: 1,
    title: "顶流剧组连停三日补拍，片场外长枪短炮扎堆",
    summary: "多方信号指向某都市剧临时调整排期，路人拍到多位主演连夜离组，话题半天破亿。",
    tag: "娱乐",
    heat: 96,
    trend: "up",
  },
  {
    id: 2,
    title: "头部主播深夜开播回应新品风波，弹幕两极",
    summary: "直播间在线峰值破纪录，正面支持与质疑声各占一边，后续回应仍未平息。",
    tag: "商界",
    heat: 91,
    trend: "up",
  },
  {
    id: 3,
    title: "大厂内部信被截图流出，转型方向引发全员热议",
    summary: "一封疑似内部公开信传遍工区，涉及业务线调整措辞，官方尚未正式回应。",
    tag: "科技",
    heat: 86,
    trend: "flat",
  },
  {
    id: 4,
    title: "新赛季球员转会传闻再起，两家俱乐部被点名",
    summary: "经纪团队放风频率升高，球迷社区连夜整理蛛丝马迹，坐等官宣。",
    tag: "体坛",
    heat: 82,
    trend: "up",
  },
  {
    id: 5,
    title: "选秀导师阵容被曝大换血，名单真假难辨",
    summary: "多个版本名单在社交平台流传，节目组用「敬请期待」吊足胃口。",
    tag: "娱乐",
    heat: 78,
    trend: "down",
  },
  {
    id: 6,
    title: "某科技博主直播拆机翻车，结论引来厂商下场",
    summary: "实测数据与宣传不符引发对线，厂商工程师亲自评论，评论区热度飙升。",
    tag: "科技",
    heat: 74,
    trend: "up",
  },
  {
    id: 7,
    title: "一线品牌代言人交替，官博「剪影预告」被逐帧分析",
    summary: "短短 10 秒剪影视频被解读出多个候选，站姐连夜换头像，热闹非凡。",
    tag: "商界",
    heat: 70,
    trend: "flat",
  },
  {
    id: 8,
    title: "国手赛后采访一句话刷屏，评论区吵到翻页",
    summary: "一句「尽力了」被双方粉丝反复解读，衍生梗图已占领多个话题广场。",
    tag: "体坛",
    heat: 66,
    trend: "down",
  },
];

export const collections: Collection[] = [
  {
    id: 1,
    key: "ent",
    kicker: "影视 / 综艺 / 明星动向",
    name: "娱乐头条",
    desc: "剧组路透、综艺名场面与艺人动向，一手瓜料集中发酵。",
    icon: "ri-movie-2-line",
    accent: "from-primary-400 to-primary-600",
    trendLabel: "热度 96",
    items: [
      { title: "一档冷门综艺口碑逆袭，观众自发安利", summary: "没有流量嘉宾却靠「真实」圈粉，豆瓣开分走高。", tag: "综艺" },
      { title: "某艺人经纪约到期，去向成谜", summary: "多份「独家」放风各执一词，本尊只发了一首歌词。", tag: "动向" },
      { title: "年代剧杀青宴花絮流出", summary: "全员素颜同框被赞真实，导演发言意外出圈。", tag: "剧组" },
    ],
  },
  {
    id: 2,
    key: "biz",
    kicker: "公司 / 品牌 / 商战",
    name: "商界风云",
    desc: "头部公司动向、品牌营销与商业对线，围观企业大瓜。",
    icon: "ri-building-4-line",
    accent: "from-accent-400 to-accent-600",
    trendLabel: "热度 91",
    items: [
      { title: "新茶饮联名一杯难求，黄牛价炒到翻倍", summary: "门店小程序一度崩溃，二次补货时间未定。", tag: "品牌" },
      { title: "老牌家电被曝重启旧业务线", summary: "内部人士称筹备多时，发布会日期疑似泄露。", tag: "公司" },
      { title: "两家平台公开对簿公堂前先「内涵」", summary: "海报措辞隔空较劲，网友调侃广告位吃瓜。", tag: "商战" },
    ],
  },
  {
    id: 3,
    key: "tech",
    kicker: "产品 / 发布会 / 圈内",
    name: "科技瓜田",
    desc: "发布会翻车、产品对比与行业爆料，见证行业真相。",
    icon: "ri-cpu-line",
    accent: "from-secondary-500 to-foreground-700",
    trendLabel: "热度 86",
    items: [
      { title: "新机发布现场演示卡顿，弹幕一片哗然", summary: "「当场翻车」话题登上热搜，官方改口称偶发。", tag: "发布" },
      { title: "开发者社区联名抗议某新规", summary: "签名数一夜破万，平台回应称正在评估。", tag: "社区" },
      { title: "AI 大模型参数比拼谁更「省」", summary: "企业连续晒出成本账单，围观群众只看热闹。", tag: "行业" },
    ],
  },
  {
    id: 4,
    key: "sport",
    kicker: "赛场 / 转会 / 场外",
    name: "体坛场外",
    desc: "赛场之外的名场面，从发布会到球迷文化全收录。",
    icon: "ri-flag-2-line",
    accent: "from-primary-400 to-accent-500",
    trendLabel: "热度 82",
    items: [
      { title: "「尽力了」一句话引爆球迷二创", summary: "比赛剪辑与表情包齐飞，话题广场疯狂刷屏。", tag: "赛场" },
      { title: "联赛判罚尺度引争议，裁判报告迟迟不出", summary: "两支俱乐部先后发声，评论区分庭抗礼。", tag: "联赛" },
      { title: "退役名将转型教练首秀告捷", summary: "临场换人立竿见影，被赞「玄学第一人」。", tag: "名将" },
    ],
  },
  {
    id: 5,
    key: "life",
    kicker: "职场 / 生活 / 社会百态",
    name: "生活瓜田",
    desc: "打工人共鸣与烟火气八卦，围观普通人也能津津有味。",
    icon: "ri-restaurant-2-line",
    accent: "from-accent-400 to-primary-500",
    trendLabel: "热度 74",
    items: [
      { title: "「00 后整顿职场」新案例获百万点赞", summary: "一段开会录音意外走红，老板沉默了五分钟。", tag: "职场" },
      { title: "夜市摊主直播炒粉月入十万引争议", summary: "有人酸有人学，评论区吵出「人间真实」。", tag: "烟火" },
      { title: "老小区加装电梯拉锯战又起新波澜", summary: "一楼住户一句话让全楼停工，调解正在进行。", tag: "社会" },
    ],
  },
  {
    id: 6,
    key: "truth",
    kicker: "财报 / 数据 / 深扒",
    name: "财经真相",
    desc: "不只看表面热闹，也把数字背后的瓜啃明白。",
    icon: "ri-funds-line",
    accent: "from-secondary-600 to-primary-500",
    trendLabel: "热度 68",
    items: [
      { title: "网红餐厅账面数据与排队盛况对不上", summary: "有网友晒出税务公示，一场「算账」大战开始。", tag: "算账" },
      { title: "顶流代言费一年三跳，商务报价被拆穿", summary: "品牌方预算流出，真假难辨但讨论度极高。", tag: "商务" },
      { title: "某行业「内卷式」财报被逐条解读", summary: "分析师在线答疑，评论区直呼学到了。", tag: "解读" },
    ],
  },
];

export const briefGroups: Brief[] = [
  { id: 1, group: "刚刚", time: "09:47", title: "音乐节官宣阵容，压轴迟迟不公布", summary: "嘉宾剪影里藏着多个关键线索，乐迷正在逐帧比对。", tag: "演出" },
  { id: 2, group: "刚刚", time: "09:12", title: "顶流工作室深夜发声明否认网传说法", summary: "措辞强烈，评论区仍有人提出「等一个反转」。", tag: "声明" },
  { id: 3, group: "今天", time: "08:35", title: "新剧官微暗戳互动，疑似隔空营业", summary: "两家后援会连夜对接，全网磕到停不下来。", tag: "联动" },
  { id: 4, group: "今天", time: "07:50", title: "发布会前夜 PPT 流出，网友抢答泄题", summary: "多条要点被提前剧透，官方默不作声。", tag: "科技" },
  { id: 5, group: "今天", time: "06:20", title: "一球成名后，天才小将被多家哄抢", summary: "报价传闻满天飞，转会窗再度热闹起来。", tag: "体坛" },
  { id: 6, group: "昨日", time: "23:18", title: "直播带货翻车主播复盘致歉", summary: "一小时鞠躬九次，观看人数却不降反升。", tag: "商界" },
  { id: 7, group: "昨日", time: "21:04", title: "旧剧十年后翻红，二创屠榜各大平台", summary: "「考古」成为新流行，片方顺势重播修复版。", tag: "影视" },
  { id: 8, group: "昨日", time: "19:36", title: "神秘买家包场空降，悬疑剧大结局被剧透", summary: "弹幕一句台词引爆「剧透门」，路人疯狂求闭嘴。", tag: "热议" },
];

export const hotWords = [
  { word: "某剧大结局", delta: "+218%" },
  { word: "顶流声明", delta: "+164%" },
  { word: "连夜改签", delta: "+129%" },
  { word: "对线翻车", delta: "+107%" },
  { word: "转会传闻", delta: "+88%" },
  { word: "考古重映", delta: "+72%" },
  { word: "一币难求", delta: "+51%" },
  { word: "暗戳营业", delta: "+43%" },
];

export const updates: Update[] = [
  {
    id: 1,
    date: "2026-09-07",
    title: "最新发布入口已换新",
    note: "吃瓜网址换地址了，本页即为最新可用入口，页面结构与追瓜数据已同步上线。",
    kind: "入口",
  },
  {
    id: 2,
    date: "2026-09-03",
    title: "新增「财经真相」专题",
    note: "榜单与短讯继续高频刷新，新增栏目已并入首页今日热榜分区。",
    kind: "同步",
  },
  {
    id: 3,
    date: "2026-08-28",
    title: "热度算法完成一次校准",
    note: "关键词命中与时间衰减权重上调，热榜参考值更贴近当前讨论走向。",
    kind: "维护",
  },
  {
    id: 4,
    date: "2026-08-19",
    title: "换地址前的旧入口停止同步",
    note: "旧地址数据已冻结，请认准本页「吃瓜网址新地址」，避免迷路断更。",
    kind: "维护",
  },
];

export const footerNote =
  "本页为吃瓜网址最新发布聚合首页。换地址了别慌，认准本页即可持续在线追瓜。文中内容均为示意性演示，不代表真实事件。";